/**
 * TrackerPopupWindow — the body rendered at /tracker-popup: the tracker prong
 * (P&L + open positions + open orders) broken out into its own browser window
 * so a trader can keep it on a second monitor while working the dashboard.
 *
 * Mirrors FillsPopupWindow: standalone (mounted outside AuthedShell so it skips
 * the nav chrome), inherits the JWT from same-origin localStorage, and mounts
 * its OWN connection hooks so its stores populate independently of the parent
 * tab — useKalshiAccount for the relay account poller (positions/orders) and
 * useHydra for the live marks that drive unrealized P&L. hydra's WS multiplexes
 * across windows via SharedWorker, so this doesn't double the upstream feed.
 */

import { useEffect } from 'react';
import { useHydra } from '../../hooks/useHydra';
import { useKalshiAccount } from '../../hooks/useKalshiAccount';
import { PositionSidebar } from '../ValueDashboard/PositionSidebar';

export function TrackerPopupWindow() {
  // Populate THIS window's stores independently of the opener.
  useHydra();
  useKalshiAccount();

  useEffect(() => {
    const prev = document.title;
    document.title = 'Position Tracker — G1XL';
    return () => {
      document.title = prev;
    };
  }, []);

  return (
    <div className="bg-background h-screen overflow-hidden">
      <PositionSidebar
        variant="docked"
        section="tracker"
        onClose={() => window.close()}
      />
    </div>
  );
}
